import React, { useContext } from 'react'
import styled from 'styled-components'
import { Flex, Hide, Text, Link } from 'pcln-design-system'
import analytics from '../../utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '../../constants/analytics'
import { Listing, CarListing } from './types'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import CarProduct from './CarProduct'
import HotelProduct from './HotelProduct'
import { InventoryWrapper } from './Common'

const ViewMoreDeals = styled(Link)`
  font-size: 12px;
  font-weight: bold;
`

const ScrollContainer = styled(Flex)`
  overflow: auto hidden;
  & > :last-child {
    margin-right: 0px;
  }
`

function fireEventForViewMoreDeals() {
  analytics.fireEvent({
    action: 'Feature Box CTA',
    category: ANALYTICS_CATEGORY_HOME,
    label: 'Cross Sell View More Deals'
  })
}

function isCarListing(listing: Listing): listing is CarListing {
  return (listing as CarListing).carExample !== undefined
}

function renderXSellProduct(listing: Listing, index: number, offerId: string) {
  if (isCarListing(listing)) {
    return (
      <CarProduct
        {...listing}
        key={listing.id}
        offerId={offerId}
        position={index + 1}
      />
    )
  }
  return (
    <HotelProduct
      {...listing}
      key={listing.hotelId}
      offerId={offerId}
      position={index + 1}
    />
  )
}

function renderXSellProducts(
  listings: Listing[],
  numProducts = 2,
  offerId: string
) {
  return listings
    .slice(0, numProducts)
    .map((listing, index) => renderXSellProduct(listing, index, offerId))
}

export default function Inventory({
  xSellMessaging,
  xSellProduct,
  xSellUrl,
  listings,
  offerId
}: {
  xSellMessaging: string
  xSellProduct: string
  xSellUrl: string
  listings: Listing[]
  offerId: string
}) {
  const { isMobile = false } = useContext(BootstrapDataContext)
  const viewMoreDeals = ({ target }: { target?: string } = {}) => (
    <ViewMoreDeals
      data-parent-offer-id={offerId}
      data-label={`View more ${xSellProduct} deals`}
      data-product={xSellProduct}
      data-has-inventory={listings.length}
      data-souce="homepage"
      data-sub-type="cross sell"
      data-rudder-event
      data-view-more
      onClick={fireEventForViewMoreDeals}
      href={xSellUrl}
      target={target}
    >
      View more {xSellProduct} deals
    </ViewMoreDeals>
  )
  const renderedProducts = renderXSellProducts(
    listings,
    isMobile ? 2 : 3,
    offerId
  )
  return (
    <InventoryWrapper>
      <Flex flexDirection="column">
        <Flex justifyContent="space-between" alignItems="baseline" mb={2}>
          <Text fontSize={[null, 1, null, null, 2]} fontWeight="bold">
            {xSellMessaging}
          </Text>
          <Hide xs sm md lg>
            {viewMoreDeals({ target: '_blank' })}
          </Hide>
        </Flex>
        <ScrollContainer>{renderedProducts}</ScrollContainer>
        <Hide xl xxl mt="10px">
          {viewMoreDeals()}
        </Hide>
      </Flex>
    </InventoryWrapper>
  )
}
